import * as React from 'react';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { AgendaMeetingListingView } from '../_components/activities/AgendaMeetingListingView';

export default function AnnualWorkgroupStatusListingPage(): JSX.Element 
{
	return (
		<ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="annualworkgroupstatus">
            <AgendaMeetingListingView
                currentActivitiesHeaderIcon='interface_glyph_comment'
                createNewButtonText='Opret ny årlig drøftelse'
                currentActivitiesHeaderText='Aktuelle årlige drøftelser'
                pastActivitiesHeaderText='Tidligere årlige drøftelser'
                pastActivitiesHeaderIcon='chat_mark'
                type='AnnualWorkgroupStatus' />
		</ProtectedPageWrapper>
	);
}
